export const MB_32 = 33554432;
